import { type SalesMetricV2 } from "./types";

export function makeMetaTotalPurchases1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalPurchases1DClick";
  const name = isDashboardV2
    ? "Meta Purchases (1D Click)"
    : "FB Purchases (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total number of conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total number of conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalPurchases1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalPurchases1DView";
  const name = isDashboardV2
    ? "Meta Purchases (1D View)"
    : "FB Purchases (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total number of conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total number of conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalPurchases7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalPurchases7DClick";
  const name = isDashboardV2
    ? "Meta Purchases (7D Click)"
    : "FB Purchases (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total number of conversions across all " +
        "channels (i.e. website, mobile app, " +
        "offline, and on-facebook) attributed to your ads"
      : "Facebook reported total number of conversions across all " +
        "channels (i.e. website, mobile app, " +
        "offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalPurchases7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalPurchases7DClick1DView";
  const name = isDashboardV2
    ? "Meta Purchases (7D Click, 1D View)"
    : "FB Purchases (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total number of conversions across all " +
        "channels (i.e. website, mobile app, " +
        "offline, and on-facebook) attributed to your ads"
      : "Facebook reported total number of conversions across all " +
        "channels (i.e. website, mobile app, " +
        "offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopPurchases1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopPurchases1DClick";
  const name = isDashboardV2
    ? "Meta shop purchases (1D Click)"
    : "FB Meta shop purchases (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported number of conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopPurchases7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopPurchases7DClick";
  const name = isDashboardV2
    ? "Meta shop purchases (7D Click)"
    : "FB Meta shop purchases (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported number of conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopPurchases7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopPurchases7DClick1DView";
  const name = isDashboardV2
    ? "Meta shop purchases (7D Click, 1D View)"
    : "FB Meta shop purchases (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported number of conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopPurchases1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopPurchases1DView";
  const name = isDashboardV2
    ? "Meta shop purchases (1D View)"
    : "FB Meta shop purchases (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported number of conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelPurchases1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelPurchases1DView";
  const name = isDashboardV2
    ? "Meta Website purchases (1D View)"
    : "FB Website purchases (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your brand site attributed to your ads"
      : "Facebook reported number of conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelPurchases1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelPurchases1DClick";
  const name = isDashboardV2
    ? "Meta Website purchases (1D Click)"
    : "FB Website purchases (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your brand site attributed to your ads"
      : "Facebook reported number of conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelPurchases7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelPurchases7DClick";
  const name = isDashboardV2
    ? "Meta Website purchases (7D Click)"
    : "FB Website purchases (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your brand site attributed to your ads"
      : "Facebook reported number of conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelPurchases7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelPurchases7DClick1DView";
  const name = isDashboardV2
    ? "Meta Website purchases (7D Click, 1D View)"
    : "FB Website purchases (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your brand site attributed to your ads"
      : "Facebook reported number of conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalRevenue1DView";
  const name = isDashboardV2
    ? "Meta Purchases conversion value (1D View)"
    : "FB Purchases conversion value (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalRevenue1DClick";
  const name = isDashboardV2
    ? "Meta Purchases conversion value (1D Click)"
    : "FB Purchases conversion value (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalRevenue7DClick";
  const name = isDashboardV2
    ? "Meta Purchases conversion value (7D Click)"
    : "FB Purchases conversion value (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaTotalRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaTotalRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta Purchases conversion value (7D Click, 1D View)"
    : "FB Purchases conversion value (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads"
      : "Facebook reported total revenue from conversions across all channels (i.e. website, mobile " +
        "app, offline, and on-facebook) attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenue1DView";
  const name = isDashboardV2
    ? "Meta shop purchases conversion value (1D View)"
    : "FB Meta shop purchases conversion value (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported revenue from conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenue1DClick";
  const name = isDashboardV2
    ? "Meta shop purchases conversion value (1D Click)"
    : "FB Meta shop purchases conversion value (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported revenue from conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenue7DClick";
  const name = isDashboardV2
    ? "Meta shop purchases conversion value (7D Click)"
    : "FB Meta shop purchases conversion value (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported revenue from conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta shop purchases conversion value (7D Click, 1D View)"
    : "FB Meta shop purchases conversion value (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from Facebook Meta shop attributed to your ads"
      : "Facebook reported revenue from conversions from Facebook Meta shop attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelRevenue1DView";
  const name = isDashboardV2
    ? "Meta Website purchases conversion value (1D View)"
    : "FB Website purchases conversion value (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your brand site attributed to your ads"
      : "Facebook reported revenue from conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelRevenue1DClick";
  const name = isDashboardV2
    ? "Meta Website purchases conversion value (1D Click)"
    : "FB Website purchases conversion value (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your brand site attributed to your ads"
      : "Facebook reported revenue from conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelRevenue7DClick";
  const name = isDashboardV2
    ? "Meta Website purchases conversion value (7D Click)"
    : "FB Website purchases conversion value (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your brand site attributed to your ads"
      : "Facebook reported revenue from conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOffsitePixelRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOffsitePixelRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta Website purchases conversion value (7D Click, 1D View)"
    : "FB Website purchases conversion value (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your brand site attributed to your ads"
      : "Facebook reported revenue from conversions from your brand site attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaThumbstopRateDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaThumbstopRateDefault";
  const name = isDashboardV2 ? "Meta thumbstop rate" : "FB thumbstop rate";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported thumbstop rate, calculated using: 3-second video views / impressions"
      : "Facebook reported thumbstop rate, calculated using: 3-second video views / impressions",
    category: "meta",
    positiveTrend: "up",
    format: "percentage",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaHoldRate1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaHoldRate1DView";
  const name = isDashboardV2
    ? "Meta hold ratio (1D View)"
    : "FB hold ratio (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported hold ratio, calculated using: thruplays / impressions"
      : "Facebook reported hold ratio, calculated using: thruplays / impressions",
    category: "meta",
    positiveTrend: "up",
    format: "percentage",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaHoldRate7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaHoldRate7DClick1DView";
  const name = isDashboardV2
    ? "Meta hold ratio (7D Click, 1D View)"
    : "FB hold ratio (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported hold ratio, calculated using: thruplays / impressions"
      : "Facebook reported hold ratio, calculated using: thruplays / impressions",
    category: "meta",
    positiveTrend: "up",
    format: "percentage",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoPlayActions1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoPlayActions1DView";
  const name = isDashboardV2
    ? "Meta video play actions (1D View)"
    : "FB video play actions (1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video starts to play. This is counted for each impression of " +
      "a video, and excludes replays",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoPlayActions7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoPlayActions7DClick1DView";
  const name = isDashboardV2
    ? "Meta video play actions (7D Click, 1D View)"
    : "FB video play actions (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video starts to play. This is counted for each impression of a " +
      "video, and excludes replays",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerView1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerView1DView";
  const name = isDashboardV2
    ? "Meta cost per content view (1D View)"
    : "FB cost per content view (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported reported cost per view, calculated using: spend / video play actions"
      : "Facebook reported reported cost per view, calculated using: spend / video play actions",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerView7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerView7DClick1DView";
  const name = isDashboardV2
    ? "Meta cost per content view (7D Click, 1D View)"
    : "FB cost per content view (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported cost per view, calculated using: spend / video play actions"
      : "Facebook reported cost per view, calculated using: spend / video play actions",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoThruplayWatchedActions1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoThruplayWatchedActions1DView";
  const name = isDashboardV2
    ? "Meta thruplay (1D View)"
    : "FB thruplay (1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played to completion, or for at least 15 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoThruplayWatchedActions7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoThruplayWatchedActions7DClick1DView";
  const name = isDashboardV2
    ? "Meta thruplay (7D Click, 1D View)"
    : "FB thruplay (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played to completion, or for at least 15 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaThruplayRate1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaThruplayRate1DView";
  const name = isDashboardV2
    ? "Meta thruplay rate (1D View)"
    : "FB thruplay rate (1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played to completion, or for at least 15 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "percentage",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaThruplayRate7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaThruplayRate7DClick1DView";
  const name = isDashboardV2
    ? "Meta thruplay rate (7D Click, 1D View)"
    : "FB thruplay rate (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played to completion, or for at least 15 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "percentage",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerThruplay1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerThruplay1DView";
  const name = isDashboardV2
    ? "Meta cost per thruplay (1D View)"
    : "FB cost per thruplay (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each ThruPlay",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerThruplay7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerThruplay7DClick1DView";
  const name = isDashboardV2
    ? "Meta cost per thruplay (7D Click, 1D View)"
    : "FB cost per thruplay (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each ThruPlay",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROAS1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROAS1DView";
  const name = isDashboardV2 ? "Meta ROAS (1D View)" : "FB ROAS (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported ROAS, this is calculated by taking the total 1D click revenue reported " +
        "by Meta and dividing by spend"
      : "Facebook reported ROAS, this is calculated by taking the total 1D click revenue reported " +
        "by Meta and dividing by spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROAS1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROAS1DClick";
  const name = isDashboardV2 ? "Meta ROAS (1D Click)" : "FB ROAS (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported ROAS, this is calculated by taking the total 1D click revenue reported " +
        "by Meta and dividing by spend"
      : "Facebook reported ROAS, this is calculated by taking the total 1D click revenue reported " +
        "by Meta and dividing by spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROAS7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROAS7DClick";
  const name = isDashboardV2 ? "Meta ROAS (7D Click)" : "FB ROAS (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported ROAS, this is calculated by taking the total 7D click revenue " +
        "reported by Facebook and dividing by spend"
      : "Facebook reported ROAS, this is calculated by taking the total 7D click revenue " +
        "reported by Facebook and dividing by spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROAS7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROAS7DClick1DView";
  const name = isDashboardV2
    ? "Meta ROAS (7D Click, 1D View)"
    : "FB ROAS (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported ROAS, this is calculated by taking the total 7D click, 1D view revenue " +
        "reported by Facebook and dividing by spend"
      : "Facebook reported ROAS, this is calculated by taking the total 7D click, 1D view revenue " +
        "reported by Facebook and dividing by spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflineRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflineRevenue1DView";
  const name = isDashboardV2
    ? "Meta Offline purchases conversion value (1D View)"
    : "FB Offline purchases conversion value (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from offline Facebook attributed to your ads"
      : "Facebook reported revenue from conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflineRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflineRevenue1DClick";
  const name = isDashboardV2
    ? "Meta Offline purchases conversion value (1D Click)"
    : "FB Offline purchases conversion value (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from offline Facebook attributed to your ads"
      : "Facebook reported revenue from conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflineRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflineRevenue7DClick";
  const name = isDashboardV2
    ? "Meta Offline purchases conversion value (7D Click)"
    : "FB Offline purchases conversion value (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from offline Facebook attributed to your ads"
      : "Facebook reported revenue from conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflineRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflineRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta Offline purchases conversion value (7D Click, 1D View)"
    : "FB Offline purchases conversion value (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from offline Facebook attributed to your ads"
      : "Facebook reported revenue from conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppRevenue1DView";
  const name = isDashboardV2
    ? "Meta Mobile app purchases conversion value (1D View)"
    : "FB Mobile app purchases conversion value (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your mobile app attributed to your ads"
      : "Facebook reported revenue from conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppRevenue1DClick";
  const name = isDashboardV2
    ? "Meta Mobile app purchases conversion value (1D Click)"
    : "FB Mobile app purchases conversion value (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your mobile app attributed to your ads"
      : "Facebook reported revenue from conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppRevenue7DClick";
  const name = isDashboardV2
    ? "Meta Mobile app purchases conversion value (7D Click)"
    : "FB Mobile app purchases conversion value (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your mobile app attributed to your ads"
      : "Facebook reported revenue from conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta Mobile app purchases conversion value (7D Click, 1D View)"
    : "FB Mobile app purchases conversion value (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported revenue from conversions from your mobile app attributed to your ads"
      : "Facebook reported revenue from conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflinePurchases1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflinePurchases1DView";
  const name = isDashboardV2
    ? "Meta Offline purchases (1D View)"
    : "FB Offline purchases (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from offline Facebook attributed to your ads"
      : "Facebook reported number of conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflinePurchases1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflinePurchases1DClick";
  const name = isDashboardV2
    ? "Meta Offline purchases (1D Click)"
    : "FB Offline purchases (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from offline Facebook attributed to your ads"
      : "Facebook reported number of conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflinePurchases7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflinePurchases7DClick";
  const name = isDashboardV2
    ? "Meta Offline purchases (7D Click)"
    : "FB Offline purchases (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from offline Facebook attributed to your ads"
      : "Facebook reported number of conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOfflinePurchases7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOfflinePurchases7DClick1DView";
  const name = isDashboardV2
    ? "Meta Offline purchases (7D Click, 1D View)"
    : "FB Offline purchases (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from offline Facebook attributed to your ads"
      : "Facebook reported number of conversions from offline Facebook attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppPurchases1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppPurchases1DView";
  const name = isDashboardV2
    ? "Meta Mobile app purchases (1D View)"
    : "FB Mobile app purchases (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your mobile app attributed to your ads"
      : "Facebook reported number of conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppPurchases1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppPurchases1DClick";
  const name = isDashboardV2
    ? "Meta Mobile app purchases (1D Click)"
    : "FB Mobile app purchases (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your mobile app attributed to your ads"
      : "Facebook reported number of conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppPurchases7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppPurchases7DClick";
  const name = isDashboardV2
    ? "Meta Mobile app purchases (7D Click)"
    : "FB Mobile app purchases (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your mobile app attributed to your ads"
      : "Facebook reported number of conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaMobileAppPurchases7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaMobileAppPurchases7DClick1DView";
  const name = isDashboardV2
    ? "Meta Mobile app purchases (7D Click, 1D View)"
    : "FB Mobile app purchases (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta reported number of conversions from your mobile app attributed to your ads"
      : "Facebook reported number of conversions from your mobile app attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenuePlusNBAttributedRevenue1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenuePlusNBAttributedRevenue1DClick";
  const name = isDashboardV2
    ? "Meta shops revenue (1D Click) + NB attributed revenue"
    : "FB Meta shops revenue (1D Click) + NB attributed revenue";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop revenue + NB attributed revenue"
      : "Facebook Meta shop revenue + NB attributed revenue",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenuePlusNBAttributedRevenue7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenuePlusNBAttributedRevenue7DClick";
  const name = isDashboardV2
    ? "Meta shops revenue (7D Click) + NB attributed revenue"
    : "FB Meta shops revenue (7D Click) + NB attributed revenue";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop revenue + NB attributed revenue"
      : "Facebook Meta shop revenue + NB attributed revenue",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenuePlusNBAttributedRevenue7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenuePlusNBAttributedRevenue7DClick1DView";
  const name = isDashboardV2
    ? "Meta shops revenue (7D Click, 1D View) + NB attributed revenue"
    : "FB Meta shops revenue (7D Click, 1D View) + NB attributed revenue";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop revenue + NB attributed revenue"
      : "Facebook Meta shop revenue + NB attributed revenue",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopTransactionsPlusNBTransactions1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopTransactionsPlusNBTransactions1DView";
  const name = isDashboardV2
    ? "Meta shops transactions (1D View) + NB transactions"
    : "FB Meta shops transactions (1D View) + NB transactions";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop purchases + NB transactions"
      : "Facebook Meta shop purchases + NB transactions",
    category: "meta",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopTransactionsPlusNBTransactions1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopTransactionsPlusNBTransactions1DClick";
  const name = isDashboardV2
    ? "Meta shops transactions (1D Click) + NB transactions"
    : "FB Meta shops transactions (1D Click) + NB transactions";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop purchases + NB transactions"
      : "Facebook Meta shop purchases + NB transactions",
    category: "meta",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopTransactionsPlusNBTransactions7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopTransactionsPlusNBTransactions7DClick";
  const name = isDashboardV2
    ? "Meta shops transactions (7D Click) + NB transactions"
    : "FB Meta shops transactions (7D Click) + NB transactions";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop purchases + NB transactions"
      : "Facebook Meta shop purchases + NB transactions",
    category: "meta",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopTransactionsPlusNBTransactions7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopTransactionsPlusNBTransactions7DClick1DView";
  const name = isDashboardV2
    ? "Meta shops transactions (7D Click, 1D View) + NB transactions"
    : "FB Meta shops transactions (7D Click, 1D View) + NB transactions";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop purchases + NB transactions"
      : "Facebook Meta shop purchases + NB transactions",
    category: "meta",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCacWithMetaShopTransactionsIncluded1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCacWithMetaShopTransactionsIncluded1DView";
  const name = isDashboardV2
    ? "Meta CAC with Meta Shop transactions included (1D View)"
    : "FB CAC with Meta Shop transactions included (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC with Meta Shop transactions included"
      : "FB CAC with Meta Shop transactions included",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCacWithMetaShopTransactionsIncluded1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCacWithMetaShopTransactionsIncluded1DClick";
  const name = isDashboardV2
    ? "Meta CAC with Meta Shop transactions included (1D Click)"
    : "FB CAC with Meta Shop transactions included (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC with Meta Shop transactions included"
      : "FB CAC with Meta Shop transactions included",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCacWithMetaShopTransactionsIncluded7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCacWithMetaShopTransactionsIncluded7DClick";
  const name = isDashboardV2
    ? "Meta CAC with Meta Shop transactions included (7D Click)"
    : "FB CAC with Meta Shop transactions included (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC with Meta Shop transactions included"
      : "FB CAC with Meta Shop transactions included",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCacWithMetaShopTransactionsIncluded7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCacWithMetaShopTransactionsIncluded7DClick1DView";
  const name = isDashboardV2
    ? "Meta CAC with Meta Shop transactions included (7D Click, 1D View)"
    : "FB CAC with Meta Shop transactions included (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC with Meta Shop transactions included"
      : "FB CAC with Meta Shop transactions included",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaShopRevenuePlusNBAttributedRevenue1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaShopRevenuePlusNBAttributedRevenue1DView";
  const name = isDashboardV2
    ? "Meta shops revenue (1D View) + NB attributed revenue"
    : "FB Meta shops revenue (1D View) + NB attributed revenue";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta shop revenue + NB attributed revenue"
      : "Facebook shop revenue + NB attributed revenue",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROASMetaShopRevenueIncluded1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROASMetaShopRevenueIncluded1DView";
  const name = isDashboardV2
    ? "Meta ROAS with Meta Shop revenue included (1D View)"
    : "FB ROAS with Meta Shop revenue included (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend"
      : "Facebook ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROASMetaShopRevenueIncluded1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROASMetaShopRevenueIncluded1DClick";
  const name = isDashboardV2
    ? "Meta ROAS with Meta Shop revenue included (1D Click)"
    : "FB ROAS with Meta Shop revenue included (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend"
      : "Facebook ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROASMetaShopRevenueIncluded7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROASMetaShopRevenueIncluded7DClick";
  const name = isDashboardV2
    ? "Meta ROAS with Meta Shop revenue included (7D Click)"
    : "FB ROAS with Meta Shop revenue included (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend"
      : "Facebook ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaROASMetaShopRevenueIncluded7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaROASMetaShopRevenueIncluded7DClick1DView";
  const name = isDashboardV2
    ? "Meta ROAS with Meta Shop revenue included (7D Click, 1D View)"
    : "FB ROAS with Meta Shop revenue included (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend"
      : "Facebook ROAS calculated as (Meta Shop Revenue + NB Attributed Revenue) / Spend",
    category: "meta",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCAC1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCAC1DClick";
  const name = isDashboardV2 ? "Meta CAC (1D Click)" : "FB CAC (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC calculated as Spend / Meta Purchases"
      : "Facebook CAC calculated as Spend / Meta Purchases",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCAC7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCAC7DClick";
  const name = isDashboardV2 ? "Meta CAC (7D Click)" : "FB CAC (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC calculated as Spend / Meta Purchases"
      : "Facebook CAC calculated as Spend / Meta Purchases",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCAC7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCAC7DClick1DView";
  const name = isDashboardV2
    ? "Meta CAC (7D Click, 1D View)"
    : "FB CAC (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC calculated as Spend / Meta Purchases"
      : "Facebook CAC calculated as Spend / Meta Purchases",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCAC1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCAC1DView";
  const name = isDashboardV2 ? "Meta CAC (1D View)" : "FB CAC (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta CAC calculated as Spend / Meta Purchases"
      : "Facebook CAC calculated as Spend / Meta Purchases",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaAOV1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaAOV1DView";
  const name = isDashboardV2 ? "Meta AOV (1D View)" : "FB AOV (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta AOV calculated as Meta Revenue / Meta Purcahses"
      : "Facebook AOV calculated as FB Revenue / FB Purcahses",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaAOV1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaAOV1DClick";
  const name = isDashboardV2 ? "Meta AOV (1D Click)" : "FB AOV (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta AOV calculated as Meta Revenue / Meta Purcahses"
      : "Facebook AOV calculated as FB Revenue / FB Purcahses",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaAOV7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaAOV7DClick";
  const name = isDashboardV2 ? "Meta AOV (7D Click)" : "FB AOV (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta AOV calculated as Meta Revenue / Meta Purcahses"
      : "Facebook AOV calculated as FB Revenue / FB Purcahses",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaAOV7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaAOV7DClick1DView";
  const name = isDashboardV2
    ? "Meta AOV (7D Click, 1D View)"
    : "FB AOV (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta AOV calculated as Meta Revenue / Meta Purcahses"
      : "Facebook AOV calculated as FB Revenue / FB Purcahses",
    category: "meta",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPostEngagement1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPostEngagement1DView";
  const name = isDashboardV2
    ? "Meta Post Engagement (1D View)"
    : "FB Post Engagement (1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "Post engagements are the total number of actions that people take involving " +
      "your ads on Facebook",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPostEngagement1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPostEngagement1DClick";
  const name = isDashboardV2
    ? "Meta Post Engagement (1D Click)"
    : "FB Post Engagement (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "Post engagements are the total number of actions that people take involving " +
      "your ads on Facebook",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPostEngagement7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPostEngagement7DClick";
  const name = isDashboardV2
    ? "Meta Post Engagement (7D Click)"
    : "FB Post Engagement (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "Post engagements are the total number of actions that people take involving " +
      "your ads on Facebook",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPostEngagement7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPostEngagement7DClick1DView";
  const name = isDashboardV2
    ? "Meta Post Engagement (7D Click, 1D View)"
    : "FB Post Engagement (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "Post engagements are the total number of actions that people take involving " +
      "your ads on Facebook",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPostEngagementDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPostEngagementDefault";
  const name = isDashboardV2
    ? "Meta Post Engagement Default"
    : "FB Post Engagement Default";

  return {
    id,
    name,
    fullName: name,
    description:
      "Post engagements are the total number of actions that people take involving " +
      "your ads on Facebook",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageEngagement1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageEngagement1DView";
  const name = isDashboardV2
    ? "Meta Page Engagement (1D View)"
    : "FB Page Engagement (1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The total number of actions that people took on your Facebook Page and its posts, " +
      "attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageEngagement1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageEngagement1DClick";
  const name = isDashboardV2
    ? "Meta Page Engagement (1D Click)"
    : "FB Page Engagement (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The total number of actions that people took on your Facebook Page and its posts, " +
      "attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageEngagement7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageEngagement7DClick";
  const name = isDashboardV2
    ? "Meta Page Engagement (7D Click)"
    : "FB Page Engagement (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The total number of actions that people took on your Facebook Page and its posts, " +
      "attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageEngagement7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageEngagement7DClick1DView";
  const name = isDashboardV2
    ? "Meta Page Engagement (7D Click, 1D View)"
    : "FB Page Engagement (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The total number of actions that people took on your Facebook Page and its posts, " +
      "attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageEngagementDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageEngagementDefault";
  const name = isDashboardV2
    ? "Meta Page Engagement Default"
    : "FB Page Engagement Default";

  return {
    id,
    name,
    fullName: name,
    description:
      "The total number of actions that people took on your Facebook Page and its posts, " +
      "attributed to your ads",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageEngagement1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageEngagement1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Page Engagement (1D View)"
    : "FB Cost Per Page Engagement (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageEngagement1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageEngagement1DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Page Engagement (1D Click)"
    : "FB Cost Per Page Engagement (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageEngagement7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageEngagement7DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Page Engagement (7D Click)"
    : "FB Cost Per Page Engagement (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageEngagement7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageEngagement7DClick1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Page Engagement (7D Click, 1D View)"
    : "FB Cost Per Page Engagement (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageEngagementDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageEngagementDefault";
  const name = isDashboardV2
    ? "Meta Cost Per Page Engagement Default"
    : "FB Cost Per Page Engagement Default";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageLikes1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageLikes1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Page Likes (1D View)"
    : "FB Cost Per Page Likes (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each Page like",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageLikes1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageLikes1DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Page Likes (1D Click)"
    : "FB Cost Per Page Likes (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each Page like",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageLikes7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageLikes7DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Page Likes (7D Click)"
    : "FB Cost Per Page Likes (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each Page like",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageLikes7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageLikes7DClick1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Page Likes (7D Click, 1D View)"
    : "FB Cost Per Page Likes (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each Page like",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPageLikesDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPageLikesDefault";
  const name = isDashboardV2
    ? "Meta Cost Per Page Likes Default"
    : "FB Cost Per Page Likes Default";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each Page like",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPostEngagement1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPostEngagement1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Post Engagement (1D View)"
    : "FB Cost Per Post Engagement (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPostEngagement1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPostEngagement1DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Post Engagement (1D Click)"
    : "FB Cost Per Post Engagement (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPostEngagement7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPostEngagement7DClick";
  const name = isDashboardV2
    ? "Meta Cost Per Post Engagement (7D Click)"
    : "FB Cost Per Post Engagement (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPostEngagement7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPostEngagement7DClick1DView";
  const name = isDashboardV2
    ? "Meta Cost Per Post Engagement (7D Click, 1D View)"
    : "FB Cost Per Post Engagement (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPerPostEngagementDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPerPostEngagementDefault";
  const name = isDashboardV2
    ? "Meta Cost Per Post Engagement Default"
    : "FB Cost Per Post Engagement Default";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each post engagement",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaLinkClicks({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaLinkClicks";
  const name = isDashboardV2
    ? "Meta Link Clicks Default"
    : "FB Link Clicks Default";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of clicks on links within the ad that led to advertiser-specified " +
      "destinations, on or off Meta technologies.",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaOutboundClicks({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaOutboundClicks";
  const name = isDashboardV2
    ? "Meta Outbound Clicks Default"
    : "FB Outbound Clicks Default";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of clicks on links that lead to destinations outside Meta technologies",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageLikes1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageLikes1DView";
  const name = isDashboardV2
    ? "Meta Page Likes (1D View)"
    : "FB Page Likes (1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta Page Likes (1D View)"
      : "FB Page Likes (1D View)",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageLikes1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageLikes1DClick";
  const name = isDashboardV2
    ? "Meta Page Likes (1D Click)"
    : "FB Page Likes (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta Page Likes (1D Click)"
      : "FB Page Likes (1D Click)",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageLikes7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageLikes7DClick";
  const name = isDashboardV2
    ? "Meta Page Likes (7D Click)"
    : "FB Page Likes (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta Page Likes (7D Click)"
      : "FB Page Likes (7D Click)",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageLikes7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageLikes7DClick1DView";
  const name = isDashboardV2
    ? "Meta Page Likes (7D Click, 1D View)"
    : "FB Page Likes (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta Page Likes (7D Click, 1D View)"
      : "FB Page Likes (7D Click, 1D View)",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaPageLikesDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaPageLikesDefault";
  const name = isDashboardV2
    ? "Meta Page Likes Default"
    : "FB Page Likes Default";

  return {
    id,
    name,
    fullName: name,
    description: isDashboardV2
      ? "Meta Page Likes Default"
      : "FB Page Likes Default",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMeta3SVideoViewsDefault({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "meta3SVideoViewsDefault";
  const name = isDashboardV2
    ? "Meta 3 Second Video Plays Default"
    : "FB 3 Second Video Plays Default";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video played for at least 3 seconds, or for nearly its total " +
      "length if it's shorter than 3 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMeta3SVideoViews1DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "meta3SVideoViews1DClick";
  const name = isDashboardV2
    ? "Meta 3 Second Video Plays (1D Click)"
    : "FB Cost Per 3 Second Video Plays (1D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video played for at least 3 seconds, or for nearly its total " +
      "length if it's shorter than 3 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMeta3SVideoViews7DClick({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "meta3SVideoViews7DClick";
  const name = isDashboardV2
    ? "Meta 3 Second Video Plays (7D Click)"
    : "FB 3 Second Video Plays (7D Click)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video played for at least 3 seconds, or for nearly its total " +
      "length if it's shorter than 3 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMeta3SVideoViews7DClick1DView({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "meta3SVideoViews7DClick1DView";
  const name = isDashboardV2
    ? "Meta 3 Second Video Plays (7D Click, 1D View)"
    : "FB 3 Second Video Plays (7D Click, 1D View)";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video played for at least 3 seconds, or for nearly its total " +
      "length if it's shorter than 3 seconds",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaCostPer3SecondVideoPlays({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaCostPer3SecondVideoPlays";
  const name = isDashboardV2
    ? "Meta Cost Per 3 Second Video Plays"
    : "FB Cost Per 3 Second Video Plays";

  return {
    id,
    name,
    fullName: name,
    description: "The average cost for each 3-second video play",
    category: "meta",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoP25Watched({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoP25Watched";
  const name = isDashboardV2
    ? "Meta Video p25 Watched"
    : "FB Video p25 Watched";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played at 25% of its length, including plays that " +
      "skipped to this point",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoP50Watched({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoP50Watched";
  const name = isDashboardV2
    ? "Meta Video p50 Watched"
    : "FB Video p50 Watched";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played at 50% of its length, including plays that " +
      "skipped to this point",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoP75Watched({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoP75Watched";
  const name = isDashboardV2
    ? "Meta Video p75 Watched"
    : "FB Video p75 Watched";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played at 75% of its length, including plays that " +
      "skipped to this point",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoP95Watched({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoP95Watched";
  const name = isDashboardV2
    ? "Meta Video p95 Watched"
    : "FB Video p95 Watched";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played at 95% of its length, including plays that " +
      "skipped to this point",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeMetaVideoP100Watched({
  isDashboardV2,
}: {
  isDashboardV2: boolean;
}): SalesMetricV2 {
  const id = "metaVideoP100Watched";
  const name = isDashboardV2
    ? "Meta Video p100 Watched"
    : "FB Video p100 Watched";

  return {
    id,
    name,
    fullName: name,
    description:
      "The number of times your video was played at 100% of its length, including plays " +
      "that skipped to this point",
    category: "meta",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}
